module.exports = __webpack_public_path__ + "static/media/CompetitionMathExamBigIcon.f33ecd3e.svg";